import { render, staticRenderFns } from "./PostReply.vue?vue&type=template&id=a846c31e&scoped=true&"
import script from "./PostReply.vue?vue&type=script&lang=js&"
export * from "./PostReply.vue?vue&type=script&lang=js&"
import style0 from "./PostReply.vue?vue&type=style&index=0&id=a846c31e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a846c31e",
  null
  
)

export default component.exports